(ns motorsaif.web.pages.personal-sign-up
  (:require
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.components.step-form :as sf]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.step-inputs :as si]
   [motorsaif.web.components.user-handle :as c-handle]
   [motorsaif.web.lib.form :as form]
   [motorsaif.log :as log]
   [motorsaif.web.svg :as svg]
   [motorsaif.validation :as validation]
   [re-frame.core :as rf :refer [dispatch]]
   [reagent.core :as r]
   [taoensso.encore :as encore]))

;; Sign up process
;;  - Sign in with Google later
;;  - Sign in with email/pass
;;    After hitting sign up, verify account screen pops up with a 4 digit code
;;    Code entries are rate limited at 5 per min
;;

;; [:div.radio-group
;;  [:div.choice
;;   [:input#one {:type "radio"
;;                :name "one"}]
;;   [:label {:for "one"}
;;    [:span.desc "Just a car owner"]
;;    [:span.title "Private"]]]
;;  [:div.choice
;;   [:input#two
;;    {:type "radio"
;;     :name "one"}]
;;   [:label {:for "two"}
;;    [:span.desc "Gather leads to loyal customers"]
;;    [:span.title "Automotive Business"]]]]

;; [{:value "private"
;;   :title "Private"
;;   :desc "Just a car owner"}
;;  {:value "business"
;;   :title "Automotive Business"
;;   :desc "Gather leads to loyal customers"}]


;; NOTE
;; WINDOW LOCATION RELOAD used as quick hack to fix state. Not setting sente user id correctly without it.



(def google-client-id "1063222127156-5mv80pmn78lqlfqqcpqq0vmcrkbsa56h.apps.googleusercontent.com")
(def redirect-uri "http://localhost:4000/login/google")
(def scopes
  "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile")

(defn google-auth-url []
  (str "https://accounts.google.com/o/oauth2/v2/auth"
       "?client_id=" google-client-id
       "&redirect_uri=" (js/encodeURIComponent redirect-uri)
       "&response_type=code"
       "&scope=" (js/encodeURIComponent scopes)
       "&access_type=offline"
       "&prompt=consent"))

(defn sign-in-with-google-button []
  [:button
   {:on-click #(set! (.-location js/window) (google-auth-url))}
   "Sign in with Google"])

(def ^:private new-account-steps
  {:start {:renderer si/personal-account
           :validate [[:user :user/email]
                      [:user :user/handle]
                      [:user :user/handle-valid]
                      [:user :user/password]]
           :next :verify-code}
   :verify-code {:renderer si/verify-email-new-user
                 :validate [[:user :user/email-verified]]
                 :finish true}})

(defn root []
  (let [init-data
        {:user {}}
        steps new-account-steps
        ;; init-data {:user {:user/email "omar@omar.com"
        ;;                   :user/handle "shit"
        ;;                   :user/password "shit"}}
        form-key :personal-account
        on-submit (fn [{:keys [all-data]}]
                    ;; Account gets created as soon as verify code is entered correctly.
                    ;; So here let's just refresh page
                    (rf/dispatch  [:common/navigate! :home])
                    (js/setTimeout (fn []
                                     (js/window.location.reload))
                                   1000))

        form-args {:schema validation/sign-up
                   ;; :change-watch #(dispatch [:reset-form form-key %])
                   :on-submit
                   {:valid on-submit
                    :invalid (fn [error]
                               ;; NOTE should never happen
                               (rf/dispatch [:toast {:type "error"
                                                     :message (str "Error registering: " error)}]))}
                   :init-data init-data}
        {:keys [*data form-params] :as form} (form/make-form form-args)]
    (fn []
      [:div#business-step-form.container-sm
       [:form.default
        form-params
        [sf/step-form {:steps steps
                       :form form
                       :title "Sign Up"
                       :init-path [:start]}]]

       ;; [sign-in-with-google-button]
       ])))
